<script setup>
import { onMounted, ref, reactive } from 'vue';
import axios from 'axios';

const props = defineProps({
    optionsUrl: {
        type: String,
        required: true,
    },
    filterColumns: {
        type: Array,
        required: true,
    },
    initialName: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['remove']);

const name = ref(props.initialName);
const filters = reactive({});
const availableOptions = ref({});
const loadingOptions = ref(false);

props.filterColumns.forEach(col => {
    filters[col.name] = 'all';
});

onMounted(() => {
    fetchOptions();
});

function fetchOptions() {
    const params = {};
    props.filterColumns.forEach(col => {
        if (filters[col.name] && filters[col.name] !== 'all') {
            params[col.name] = filters[col.name];
        }
    });

    loadingOptions.value = true;
    axios.get(props.optionsUrl, { params }).then(response => {
        availableOptions.value = response.data;
    }).finally(() => {
        loadingOptions.value = false;
    });
}

function onFilterChange() {
    fetchOptions();
}

function getValues() {
    const entry = { name: name.value };
    props.filterColumns.forEach(col => {
        entry[col.name] = filters[col.name];
    });
    return entry;
}

defineExpose({ getValues });
</script>

<template>
    <div class="dashboard-dataset-form row mb-2">
        <div class="col">
            <label>
                Name
                <input type="text" class="form-control" v-model="name" />
            </label>
        </div>
        <div class="col" v-for="col in filterColumns" :key="col.name">
            <label>
                {{ col.title }}
                <select class="form-control" v-model="filters[col.name]" @change="onFilterChange"
                    :disabled="loadingOptions">
                    <option v-if="loadingOptions" disabled>Laden...</option>
                    <option v-for="o in (availableOptions[col.name] || [])" :key="o.value" :value="o.value">{{ o.name }}
                    </option>
                </select>
            </label>
        </div>
        <div class="col-auto d-flex pb-2">
            <button class="btn btn-outline-danger btn-sm" @click="$emit('remove')">X</button>
        </div>
    </div>
</template>
